import { useState } from "react";
import "./UserAuth.css";
import { api } from '../config/api';
export default function UserRegister({ onRegisterSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (password !== repeatPassword) {
      setMessage("Passwords do not match!");
      return;
    }
    
    // const response = await fetch('http://127.0.0.1:5000/api/register', {
    const response = await fetch(api.register, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    const data = await response.json();

    if (response.ok) {
      alert("Registration successful. Please log in.");
      onRegisterSuccess();
    } else {
      setMessage(data.message || "Registration failed");
    }
  };

  return (
    <form onSubmit={handleRegister} className="mainContainer">
      <div className="titleContainer">
        <h4>Register</h4>
      </div>
      <div className="inputContainer">
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter your username"
          className="inputBox"
          required
        />
      </div>
      <br />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Enter password"
        className="inputBox"
        required
      />
      <br />
      <input
        type="password"
        value={repeatPassword}
        onChange={(e) => setRepeatPassword(e.target.value)}
        placeholder="Repeat Password"
        className="inputBox"
        required
      />
      <br />
      <button type="submit" className="inputRegister">
        Register
      </button>
      <p className="errorLabel">{message}</p>
    </form>
  );
}
